import { claudeCode } from "./claude-code";
import { cursorAgent } from "./cursor-agent";
import { base16, base24, css, themeJson } from "./formats";
import { ghostty } from "./ghostty";
import { herdr } from "./herdr";
import { neovim } from "./neovim";
import type { Exporter, ExporterId } from "./types";
import { weechat } from "./weechat";

/** App exporters first, in the order they should be applied (terminal palette first). */
export const EXPORTERS: Exporter[] = [
  ghostty,
  herdr,
  neovim,
  weechat,
  cursorAgent,
  claudeCode,
  base16,
  base24,
  css,
  themeJson,
];

export function exporter(id: ExporterId): Exporter {
  const e = EXPORTERS.find((x) => x.id === id);
  if (!e) throw new Error(`unknown exporter ${id}`);
  return e;
}
